<template>
  <div class="attendance-modal">
    <div
      class="report-backdrop"
      @click.self="$emit('closer', { load: false })"
    >
      <div class="modal">
        <form @submit.prevent="handleSubmit">
          <Spinner class="card" v-if="loading"/>
          <div class="learner-info">
            <label>{{ record.displayName }}</label>
            <label>{{ record.grade }}</label>
          </div>

          <div class="work-items">
            <table class="item-list">
              <tr class="table-heading flex">
                <th class="week">Week</th>
                <th class="day">M</th>
                <th class="day">T</th>
                <th class="day">W</th>
                <th class="day">T</th>
                <th class="day">F</th>
              </tr>
              <tr class="table-items flex" v-for="(week, index) in attendance" :key="index">
                <td class="week">
                  <input type="text" v-model="week.week" disabled>
                </td>
                <td class="day">
                <select name="monday" id="monday" v-model="week.monday">
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                  </option>
                  <option value="Present">
                    &#10004; Present
                  </option>
                  <option value="Absent">
                    &#10008; Absent
                  </option>
                  <option value="Sick">
                    S - Sick
                  </option>
                  <option value="Holiday">
                    H - Holiday
                  </option>
                </select>
                </td>
                <td class="day">
                <select name="tuesday" id="tuesday" v-model="week.tuesday">
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                  </option>
                  <option value="Present">
                    &#10004; Present
                  </option>
                  <option value="Absent">
                    &#10008; Absent
                  </option>
                  <option value="Sick">
                    S - Sick
                  </option>
                  <option value="Holiday">
                    H - Holiday
                  </option>
                </select>
                </td>
                <td class="day">
                <select name="wednesday" id="wednesday" v-model="week.wednesday">
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                  </option>
                  <option value="Present">
                    &#10004; Present
                  </option>
                  <option value="Absent">
                    &#10008; Absent
                  </option>
                  <option value="Sick">
                    S - Sick
                  </option>
                  <option value="Holiday">
                    H - Holiday
                  </option>
                </select>
                </td>
                <td class="day">
                <select name="thursday" id="thursday" v-model="week.thursday">
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                  </option>
                  <option value="Present">
                    &#10004; Present
                  </option>
                  <option value="Absent">
                    &#10008; Absent
                  </option>
                  <option value="Sick">
                    S - Sick
                  </option>
                  <option value="Holiday">
                    H - Holiday
                  </option>
                </select>
                </td>
                <td class="day">
                <select name="friday" id="friday" v-model="week.friday">
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                  </option>
                  <option value="Present">
                    &#10004; Present
                  </option>
                  <option value="Absent">
                    &#10008; Absent
                  </option>
                  <option value="Sick">
                    S - Sick
                  </option>
                  <option value="Holiday">
                    H - Holiday
                  </option>
                </select>
                </td>
                <TrashIcon @click="deleteWeekItem(week.id)" class="icon" />
              </tr>
            </table>
            <div class="flex reg-info">
              <div @click="addNewAttendanceEntry" class="flex btn">
                <img src="@/assets/icon-plus.svg" alt="" />
                Add New Week
              </div>
              <div class="flex btn">
                Attendance: {{ daysPresent.length }}/{{ totalDays.length }}
              </div>
            </div>
          </div>

          <button>SAVE</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref, watchEffect } from 'vue' // , toRefs
import { uid } from 'uid'
import Spinner from './Spinner.vue'
import { db, updateDoc, doc } from '@/firebase/config'
import { TrashIcon } from '@heroicons/vue/outline'

export default {
  name: 'AttendanceRegisterModal',
  props: ['record'],
  components: { Spinner, TrashIcon },
  setup (props, context) {
    const currentUser = inject('currentUser')
    const attendance = ref([])
    const loading = ref(false)
    const week = ref(0)
    const daysAbsent = ref([])
    const daysPresent = ref([])
    const daysSick = ref([])
    const totalDays = ref([])

    const deleteWeekItem = (id) => {
      attendance.value = attendance.value.filter((week) => week.id !== id)
    }

    const addNewAttendanceEntry = () => {
      week.value += 1
      attendance.value.push({
        id: uid(),
        week: week.value,
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: ''
      })
    }

    const handleSubmit = async () => {
      loading.value = true
      const post = {
        displayName: props.record.displayName,
        grade: props.record.grade,
        createdAt: props.record.createdAt,
        attendance: attendance.value,
        subjectList: props.record.subjectList
      }
      const learnerRecordRef = doc(db,
        '/schools/inspire-schools/' + currentUser.state.grade + '/reports/teacher',
        props.record.id)

      await updateDoc(learnerRecordRef, post)
      context.emit('closer', {
        load: true
      })
    }
    const checkRegister = {
      present: 'Present',
      absent: 'Absent',
      sick: 'Sick',
      holiday: 'Holiday'
    }

    function isAbsent (obj) {
      // Present days
      if (obj.monday === this.present) {
        if (daysPresent.value.indexOf(obj.week + ' monday ' + obj.monday) === -1) {
          daysPresent.value.push(obj.week + ' monday ' + obj.monday)
        }
      }
      if (obj.tuesday === this.present) {
        if (daysPresent.value.indexOf(obj.week + ' tuesday ' + obj.tuesday) === -1) {
          daysPresent.value.push(obj.week + ' tuesday ' + obj.tuesday)
        }
      }
      if (obj.wednesday === this.present) {
        if (daysPresent.value.indexOf(obj.week + ' wednesday ' + obj.wednesday) === -1) {
          daysPresent.value.push(obj.week + ' wednesday ' + obj.wednesday)
        }
      }
      if (obj.thursday === this.present) {
        if (daysPresent.value.indexOf(obj.week + ' thursday ' + obj.thursday) === -1) {
          daysPresent.value.push(obj.week + ' thursday ' + obj.thursday)
        }
      }
      if (obj.friday === this.present) {
        if (daysPresent.value.indexOf(obj.week + ' friday ' + obj.friday) === -1) {
          daysPresent.value.push(obj.week + ' friday ' + obj.friday)
        }
      }
      // Sick days
      if (obj.monday === this.sick) {
        if (daysSick.value.indexOf(obj.week + ' monday ' + obj.monday) === -1) {
          daysSick.value.push(obj.week + ' monday ' + obj.monday)
        }
      }
      if (obj.tuesday === this.sick) {
        if (daysSick.value.indexOf(obj.week + ' tuesday ' + obj.tuesday) === -1) {
          daysSick.value.push(obj.week + ' tuesday ' + obj.tuesday)
        }
      }
      if (obj.wednesday === this.sick) {
        if (daysSick.value.indexOf(obj.week + ' wednesday ' + obj.wednesday) === -1) {
          daysSick.value.push(obj.week + ' wednesday ' + obj.wednesday)
        }
      }
      if (obj.thursday === this.sick) {
        if (daysSick.value.indexOf(obj.week + ' thursday ' + obj.thursday) === -1) {
          daysSick.value.push(obj.week + ' thursday ' + obj.thursday)
        }
      }
      if (obj.friday === this.sick) {
        if (daysSick.value.indexOf(obj.week + ' friday ' + obj.friday) === -1) {
          daysSick.value.push(obj.week + ' friday ' + obj.friday)
        }
      }
      // Total days
      if (obj.monday !== '' && obj.monday !== this.holiday) {
        if (totalDays.value.indexOf(obj.week + ' monday ') === -1) {
          totalDays.value.push(obj.week + ' monday ')
        }
      }
      if (obj.tuesday !== '' && obj.tuesday !== this.holiday) {
        if (totalDays.value.indexOf(obj.week + ' tuesday ') === -1) {
          totalDays.value.push(obj.week + ' tuesday ')
        }
      }
      if (obj.wednesday !== '' && obj.wednesday !== this.holiday) {
        if (totalDays.value.indexOf(obj.week + ' wednesday ') === -1) {
          totalDays.value.push(obj.week + ' wednesday ')
        }
      }
      if (obj.thursday !== '' && obj.thursday !== this.holiday) {
        if (totalDays.value.indexOf(obj.week + ' thursday ') === -1) {
          totalDays.value.push(obj.week + ' thursday ')
        }
      }
      if (obj.friday !== '' && obj.friday !== this.holiday) {
        if (totalDays.value.indexOf(obj.week + ' friday ') === -1) {
          totalDays.value.push(obj.week + ' friday ')
        }
      }
    }

    watchEffect(() => {
      attendance.value.map(isAbsent, checkRegister)
    })

    onMounted(() => {
      if (props.record.attendance) {
        attendance.value = [...props.record.attendance]
        week.value = props.record.attendance[attendance.value.length - 1].week
          ? props.record.attendance[attendance.value.length - 1].week : 0
      }
    })

    return { handleSubmit, attendance, deleteWeekItem, loading, addNewAttendanceEntry, daysPresent, daysAbsent, daysSick, totalDays }
  }
}
</script>

<style>
    .attendance-modal .report-backdrop {
        top: 0;
        left: 0;
        position: fixed;
        background-color: fuchsia;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        /* z-index: 99; */
    }
    .attendance-modal .modal {
        border-radius: 10px;
        max-width: 700px;
        width: 80vw;
        max-height: 90vh;
        background: #fff;
        padding: .1em;
        overflow: auto;
    }
    .attendance-modal label {
      display: block;
      font-weight: 700;
      color: #010222;
    }
    .attendance-modal .modal form {
      width: 95% !important;
      display: flex;
      flex-direction: column;
      max-width: 700px;
      margin: 0 auto;
      padding: 0;
    }
    .attendance-modal .modal .learner-info {
      display: flex;
      justify-content: space-around;
    }
    .attendance-modal .modal div {
      border: none;
    }
    .attendance-modal .modal .work-items .item-list {
      width: 100%;
    }
    .table-heading,.table-items {
      gap: 16px;
      font-size: 12px;
    }
    .week {
      flex-basis: 15%;
    }
    .day {
      flex-basis: 15%;
    }
    .table-heading {
      margin-bottom: 16px;
    }
    th {
      text-align: left;
    }
    .table-items {
      position: relative;
      margin-bottom: 24px;
    }
    .attendance-modal .modal .work-items img {
      position: absolute;
      top: 15px;
      right: 0;
      width: 12px;
      height: 16px;
      cursor: pointer;
    }
    .attendance-modal .btn {
      color: #252945;
      align-items: center;
      justify-content: center;
      background: #eee;
      width: 100%;
      border-radius: 30px;
      position: relative;
    }
    .attendance-modal .modal .work-items .btn img {
      margin-right: 10px;
      top: 8px;
    }
    .attendance-modal .icon {
      max-width: 17px;
      cursor: pointer;
    }
    .attendance-modal .reg-info {
      justify-content: space-between;
    }
</style>
